import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button, FormField, Modal } from '@/components/ui';
import { Input } from '@/components/ui/input';
import { getApiErrorMessage } from '@/lib/axios';
import { mapUser } from '@/services/auth';
import { updateMonCompte } from '@/services/parametres';
import { useAuthStore } from '@/store/authStore';
import { toast } from '@/store/toastStore';

export function ProfilModal({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (open && user) { setNom(user.nom); setPrenom(user.prenom); setEmail(user.email); setPassword(''); }
  }, [open, user]);

  const save = useMutation({
    mutationFn: () => updateMonCompte({ nom, prenom, email, ...(password ? { password } : {}) }),
    onSuccess: (dto) => { setUser(mapUser(dto)); onOpenChange(false); toast.success('Compte mis à jour.'); },
    onError: (e) => toast.error(getApiErrorMessage(e)),
  });

  return (
    <Modal open={open} onOpenChange={onOpenChange} title="Mon compte"
      footer={<><Button variant="secondary" onClick={() => onOpenChange(false)}>Annuler</Button><Button onClick={() => save.mutate()} loading={save.isPending}>Enregistrer</Button></>}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormField label="Prénom" required><Input value={prenom} onChange={(e) => setPrenom(e.target.value)} /></FormField>
        <FormField label="Nom" required><Input value={nom} onChange={(e) => setNom(e.target.value)} /></FormField>
        <FormField label="Email" className="sm:col-span-2"><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} /></FormField>
        <FormField label="Nouveau mot de passe" className="sm:col-span-2">
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" placeholder="Laisser vide pour ne pas changer" />
        </FormField>
        {user && <p className="text-xs text-content-muted sm:col-span-2">Rôle : <span className="font-medium capitalize">{user.role.toLowerCase()}</span> — vos accès aux modules sont définis par l'administrateur.</p>}
      </div>
    </Modal>
  );
}
